import { LITERAL, LEFT, RIGHT } from '../constants';
import { FormatToParts } from '../interfaces';

const getSpacing = (parts: FormatToParts, position: string | undefined) => {
  if (position === LEFT) {
    return parts[1].type === LITERAL;
  }
  if (position === RIGHT) {
    return parts[parts.length - 2].type === LITERAL;
  }
  return false;
};

export default getSpacing;
